
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/category/[categorySlug]",
      function () {
        return require("private-next-pages/blog/category/[categorySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/category/[categorySlug]"])
      });
    }
  